import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Pagination } from "antd";
import axios from "axios";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import SearchBox from "../../../components/SearchBox";
import DepartmentModal from "../../../components/modelpopup/DepartmentModal";
import { base_url } from "../../../base_urls";
import {
  itemRender,
  pageSizeOptions,
  handlePageChange,
  defaultPagination
} from "utils/table";
import {getDepartment} from "api/services/common"
import { useSearchParams } from 'react-router-dom';
import { useMediaQuery } from "react-responsive";
import { SkeltonLoader } from "components/skeltonLoader";

import { Button } from "components/Button";
import { syncDataApi } from "api/services/settings";
import { toast , Bounce } from "react-toastify";



const Department = () => {
  const [departmentData, setDepartmentData] = useState([])
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [view, setView] = useState(isMobile? "grid":"list");


 

  const syncHandler = (type) => {
    setLoading(true)
    let payload = {
      data_sync_type: type
    }
    syncDataApi(payload).then((res) => {
      setLoading(false)
      console.log(res);
      toast.success(res?.data?.message || 'Sync request successfully sent', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });

    }).catch((err) => {
      setLoading(false)
      console.log(err);
      toast.error(err?.response?.data?.message || 'Something went wrong', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    })

    console.log("syncHandler");
  }
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle="Sync Data"
            title="Settings"
            subtitle="Sync Data"
            // modal="#add_department"
            name="Sync Data"
            // view={view}
            // setView={setView}
          />
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-6">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title">Sync All Data</h4>
                  <Button
                  className="btn btn-primary  "
                  label="Sync"
                  onClick={() => syncHandler("all")}
                    loading={loading}
                    disabled={loading}
                  />
                </div>
              </div>
           
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title">Sync Master Data</h4>
                  <Button
                  className="btn btn-primary  "
                  label="Sync"
                  onClick={() => syncHandler("master")}
                    loading={loading}
                  disabled={loading}
                  />
                </div>
              </div>

              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title">Sync Employee Data</h4>
                  <Button
                  className="btn btn-primary  "
                  label="Sync"
                  onClick={() => syncHandler("user")}
                  loading={loading}
                  disabled={loading}
                  />
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default Department;
